import { CreditCardType } from '@ui-kit/components/cardType';
import { Stripe } from '@stripe/stripe-js';
import { Subject, BehaviorSubject } from 'rxjs';
import { ITable } from '@base/features/game/model/interfaces';

export type Price = {
  description: string;
  price: number;
  tickets: number;
};

export enum PurchaseMethod {
  MOBILE = 'mobile',
  CARD = 'card',
  PAYPAL = 'paypal',
  STRIPE = 'stripe',
  AMAZON = 'amazon',
  WIN = 'windows',
  MAC = 'mac',
}

export type PurchaseData = {
  amount: string;
  first_name: string;
  last_name: string;
  card_type: CreditCardType;
  card_number: string;
  cvn: string;
  exp_mon: string;
  exp_year: string;
  address: string;
  city: string;
  state: string;
  country: string;
  zip: string;
};

export type AmazonPurchaseOptions = {
  accessKey: string;
  amount: string;
  lwaClientId: string;
  sellerId: string;
  sellerOrderId: string;
  signature: string;
};

export type StripeIntent = {
  id: string;
  client_secret: string;
  amount: string;
  description: string;
};

export type AmazonPurchaseData = {
  price: string;
  accessToken: string;
  orderReferenceId: string;
};
export interface ITicketService {
  accountBalance: BehaviorSubject<number>;
  haveSufficientBalance(table: ITable): boolean;
  getPaypalToken(): Promise<string>;
  onTicketsModal: Subject<PurchaseMethod[]>;
  purchase(purchaseData: PurchaseData): Promise<void>;
  canBuyTickets(): Promise<boolean>;
  openPaymentModal(): Promise<void>;
  closePaymentModal(): void;
  getPrices(): Promise<Price[]>;
  paypalBuy(price: string): Promise<string>;
  initStripe(): Promise<Stripe | null>;
  stripeId(price: string): Promise<string>;
  stripeIntent(amount: string): Promise<StripeIntent>;
  stripeConfirm(id: string): Promise<void>;
  amazonPurchase(amount: string): Promise<AmazonPurchaseOptions>;
  amazonBuy(data: AmazonPurchaseData): Promise<void>;
}
